import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { getBuildIdQuery, ILink } from '@ncg/data';
import { FooterNavModule, LinkModule, NavigationService, SettingsService, SocialLinksModule } from '@ncg/ui';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'ncg-footer',
    template: `
        <footer class="footer">
            <ng-container *ngIf="navigationService.getNavigationById() | async as items">
                <ncg-footer-nav class="section footer-top" [items]="items" *ngIf="items?.length && !isFrontPage"></ncg-footer-nav>
            </ng-container>

            <div class="section footer-bottom" [class.pt-6]="isFrontPage" *ngIf="settingsService.get() | async as settings">
                <div class="container is-flex" [class.is-justify-content-space-between]="isFrontPage">
                    <div class="footer-bottom__logo">
                        <ncg-link [link]="settings.logoLink ?? logoLink">
                            <svg-icon-sprite
                                [src]="'assets/images/sprite-multi.svg' + buildIdQuery + '#honda-logo-and-slogan'"
                                [viewBox]="'0 0 164 35'"
                                [width]="'160px'"
                                [height]="'34px'"
                            ></svg-icon-sprite>
                        </ncg-link>
                    </div>
                    <div class="footer-bottom__links" *ngIf="!isFrontPage">
                        <nav class="footer-bottom__navbar navbar" *ngIf="settings.footerLinks?.length">
                            <ncg-link
                                *ngFor="let link of settings.footerLinks"
                                [link]="link"
                                styleClass="footer-bottom__item footer-bottom__item--divider navbar-item"
                            ></ncg-link>
                        </nav>
                        <div class="footer-bottom__copyright" *ngIf="settings.copyright">
                            <p>{{ settings.copyright }}</p>
                        </div>
                    </div>
                    <ncg-social-links
                        *ngIf="settings.socialLinks"
                        class="footer-bottom__social"
                        [socialLinks]="settings.socialLinks"
                    ></ncg-social-links>
                </div>
            </div>
        </footer>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit, OnDestroy {
    buildIdQuery = getBuildIdQuery();
    isFrontPage = false;
    logoLink: ILink = {
        isExternal: false,
        name: '',
        url: '/',
    };
    private readonly unsubscribe = new Subject<void>();

    constructor(
        public readonly navigationService: NavigationService,
        public readonly settingsService: SettingsService,
        private readonly cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.navigationService
            .isFrontPage()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((data) => {
                this.isFrontPage = data;
                this.cd.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
@NgModule({
    declarations: [FooterComponent],
    imports: [CommonModule, SocialLinksModule, IconSpriteModule, FooterNavModule, LinkModule],
    exports: [FooterComponent],
})
export class FooterComponentModule {}
